import { AttachmentTableModalAccess } from './AttachmentsTableModal';
import { OpenButtonAccess } from './AttachmentsTableModal.components';

export const AttachmentTableModal = AttachmentTableModalAccess;
export const AttachmentTableModalComponents = { OpenButton: OpenButtonAccess };
